import hasClass from './hasClass';
import addClass from './addClass';
import removeClass from './removeClass';
export default (function (target, className) {
  if (hasClass(target, className)) {
    return removeClass(target, className);
  }

  return addClass(target, className);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-lib/es/classNames/toggleClass.js
// module id = 2158
// module chunks = 33